import { createRef, PureComponent, ReactNode, RefObject } from 'react';
import classNames from 'classnames';
import { SpotSvg } from '../SpotSvg';

export interface SpotDiHeaderElement {
    id: string | number;
    value?: ReactNode | string;
    isDivider?: boolean;
    isHeading?: boolean;
    className?: string;
    selected?: boolean;
}

export interface SpotDiHeaderProps {
    title?: string | ReactNode;
    titleClassName?: string;
    titleIconClassName?: string;
    elements: SpotDiHeaderElement[];
    onChange: any;
    wrapText?: boolean;
    className?: string;
    ['data-automation-id']?: string;
}

interface State {
    isOpen: boolean;
}

export class SpotDiHeader extends PureComponent<SpotDiHeaderProps, State> {
    private readonly wrapperRef: RefObject<HTMLDivElement> = createRef();

    static defaultProps = {
        wrapText: true,
    };

    state = {
        isOpen: false,
    };

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    render() {
        const { title, titleClassName, titleIconClassName, elements, wrapText, className, ['data-automation-id']: automationId } = this.props;

        return (
            <div
                className={classNames('spot-di', className)}
                style={{ display: 'inline-block', marginLeft: 8, marginRight: 0 }}
                ref={this.wrapperRef}
                data-automation-id={automationId}
            >
                <span onClick={this.openClose} className={classNames('spot-di__header', titleClassName)}>
                    {title}
                    <SpotSvg icon="caret-down" className={classNames('spot-dropdown__caret', titleIconClassName)} />
                </span>

                <div
                    className="spot-popover spot-popover--no-inset spot-popover--align-rightcaret spot-popover--shown"
                    style={{ display: this.state.isOpen ? 'block' : 'none', minWidth: 180 }}
                >
                    <div className="spot-di__content">
                        <div className="spot-di__content-items">
                            {elements.map((element, index) => {
                                const { isHeading, isDivider, id, value, className: itemClassName, selected } = element;
                                const classes = classNames(
                                    {
                                        'spot-di__content-item': !isDivider && !isHeading,
                                        'spot-dropdown__content--divider': isDivider,
                                        'spot-di__content-profile': isHeading,
                                        'spot-dropdown__content-item--single-line': !wrapText,
                                        'spot-dropdown__content-item--selected': selected,
                                    },
                                    itemClassName,
                                );

                                return (
                                    <>
                                        {Boolean(isHeading) && (
                                            <div
                                                key={id}
                                                className={classes}
                                                style={{ lineHeight: 'unset' }}
                                                onClick={() => !isHeading && this.onChange(element)}
                                            >
                                                {value}
                                            </div>
                                        )}
                                        {!isHeading && (
                                            <div key={id} className={classes} onClick={() => !isHeading && this.onChange(element)}>
                                                <a className="spot-link spot-link--ellipsis">{value}</a>
                                            </div>
                                        )}
                                    </>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private openClose = () => {
        this.setState({ isOpen: !this.state.isOpen });
    };

    private onChange = ({ id }: SpotDiHeaderElement) => {
        this.props.onChange(id);
        this.openClose();
    };

    private handleClickOutside = (event) => {
        const { isOpen } = this.state;
        if (isOpen && this.wrapperRef && !this.wrapperRef.current!.contains(event.target)) {
            this.setState({ isOpen: false });
        }
    };
}
